<template>
    <div class="container pad-2 pcenter bg-color-dgray round-md pad-1-s">
        <article class="container fsize-1d6 pad-v-3 fsize-1d2-s pad-h-1-s" md>基于清华 DaaS 数据库的应用数据包已经 / 正在服务以下客户</article>

        <!--pc 端适配-->
        <div class="hide-s">
            <b-grid :col-data="cases"
                    :line="['neutral', 1]"
                    outline-color="dgray">
                <b-hot v-for="(item, index) of cases.items" :slot="item.id" :key="item.id"
                       styles="rel flex-column h-17"
                       @on_enter="$_show_detail(index)"
                       @on_leave="$_hide_detail(index)">
                    <div class="pad-1d5">
                        <img :src="require(`@/assets/img/case/${item.img}.jpg`)" class="h-4 round-sm" />
                        <div class="fsize-1d4 mrg-v-1">{{item.user}}</div>
                        <div class="fsize-1d2 alpha-d5">{{item.pro_name}}</div>
                    </div>
                    <div :class="`trans-fast abs max bg-color-dark t-0 l-0 ${item.show? 'alpha-d9': 'alpha-0'}`">
                        <article class="abs max fsize-1d1 pleft pad-2 auto-scroll">
                            {{item.desc}}
                        </article>
                    </div>
                </b-hot>
            </b-grid>
        </div>

        <!--mob 端适配-->
        <div class="hide show-s">
            <b-grid :col-data="cases"
                    :line="['neutral', 1]"
                    outline-color="dgray">
                <b-hot v-for="(item, index) of cases.items" :slot="item.id" :key="item.id"
                       styles="rel flex-column h-17"
                       @on_click="$_show_detail(index)">
                    <div class="pad-1">
                        <img :src="require(`@/assets/img/case/${item.img}.jpg`)" class="h-4 round-sm" />
                        <div class="fsize-1d4 mrg-v-1">{{item.user}}</div>
                        <div class="fsize-1d3 alpha-d5">{{item.pro_name}}</div>
                    </div>
                    <div :class="`trans-fast abs max bg-color-dark t-0 l-0 ${item.show? 'alpha-d9': 'alpha-0'}`">
                        <article class="abs max fsize-1d1 pleft pad-2 auto-scroll">
                            {{item.desc}}
                        </article>
                        <a href="javascript:;" @click="$_hide_detail(index, $event)"
                           class="abs t-5px r-5px">
                                <span class="flex-5 bg-color-mgray round w-2 h-2">
                                    <i class="ico-fail"></i>
                                </span>
                        </a>
                    </div>
                </b-hot>
            </b-grid>
        </div>
    </div>
</template>

<script>
    import BHot from "@/components/BTXUI/core/b-hot"
    import BGrid from "@/components/BTXUI/core/b-grid"

    export default {
        name: "sec-customer-widget",
        components: {
            BHot,
            BGrid
        },
        data(){
            return {

                //付费用户
                cases: {
                    common_plan: "col-3 col-6-s",
                    items: [
                        {
                            id: "fgw",
                            img: "fgw",
                            user: "国家发改委",
                            pro_name: "中国宏观经济指标人工智能大数据监测分析方法研究",
                            desc: "重点研发监测我国GDP动态增速，通过自动化的数据驱动方式对我国以GDP增速为核心的宏观经济指标开展高频度监测分析，重点解决统计数据相对滞后和重大事件经济冲击实时预警等问题，为基于大数据的宏观经济形势分析提供辅助服务。",
                            show: false
                        },
                        {
                            id: "qh_manager",
                            img: "qh_manager",
                            user: "清华大学公共管理学院",
                            pro_name: "中国区域高质量发展评测大数据技术服务",
                            desc: "研究全国、省区、地市和县域四级高质量发展评测指标体系、高质量发展评测指数等内容。",
                            show: false
                        },
                        {
                            id: "qh_city",
                            img: "qh_city",
                            user: "清华大学中国城市研究院",
                            pro_name: "第三方城市体检",
                            desc: "项目由国家住房和城乡建设部主导，在推动城市高质量发展与治理能力现代化背景下，将城市体检作为城市治理创新型手段，对全国性和常态化城市进行体检。",
                            show: false
                        },
                        {
                            id: "qh_th",
                            img: "qh_th",
                            user: "北京清华同衡规划设计研究院",
                            pro_name: "区域总规",
                            desc: "",
                            show: false
                        },
                        {
                            id: "njzky",
                            img: "njzky",
                            user: "南京中科院地理与湖泊研究所",
                            pro_name: "",
                            desc: "",
                            show: false
                        },
                        {
                            id: "qh_th2",
                            img: "qh_th",
                            user: "清华同衡城士科技",
                            pro_name: "分区分级精准掌握防疫期间复工复产情况",
                            desc: "为发挥特殊时期智库作用，助力政府部门多维度掌握分区分级精准复工复产情况，优化疫情防控措施，使用DaaS 实时AI大数据技术试算新冠病毒防疫期间的全国商业办公区域人口活跃度指标和劳务输出区县务工人员离乡返工率，供各方面研究参考。",
                            show: false
                        },
                        {
                            id: "zsdx",
                            img: "zsdx",
                            user: "中山大学地理科学与规划学院",
                            pro_name: "区县建设和规划",
                            desc: "",
                            show: false
                        },
                        {
                            id: "qh",
                            img: "qh",
                            user: "清华大学",
                            pro_name: "借助AI大数据技术以教育舆情为基础提升决策类信息报送",
                            desc: "探索在公共管理服务领域，借助AI大数据平台，形成有实时数据支撑，AI自动成文，提供具有辅助决策性的高质量信息。",
                            show: false
                        },
                        {
                            id: "qh_fs",
                            img: "qh_fs",
                            user: "清华大学佛山先进制造研究院",
                            pro_name: "基于AI大数据的佛山高质量发展指数研究",
                            desc: "开展基于AI大数据的佛山高质量发展指数研究，实现高质量发展指数的全面、实时、动态监控与展示，把事后响应转变为事前预测，早发现、早应对，有效提供辅助决策，实现真正的数据驱动区域社会治理变革，提升区域治理能力。",
                            show: false
                        },
                        {
                            id: "bjgs",
                            img: "bjgs",
                            user: "北京工商大学",
                            pro_name: "农地“三权分置”的信托模式研究",
                            desc: "国家社科基金资助项目，基于大数据采集和分析方法，解析福建沙县、浙江绍兴等开展农村土地流转信托的地区主要经济指标变化，提炼各功能区发展特征、发展差异和关键短板指标等。",
                            show: false
                        },
                        {
                            id: "bjgs2",
                            img: "bjgs",
                            user: "北京工商大学",
                            pro_name: "河南等10省（区、市）农业综合行政执法示范县、示范单位创建评审",
                            desc: "采用大数据对河南等10省50余市县就重大农产品治理安全事件或违法行为进行不稳定事件的历史监测。",
                            show: false
                        },
                    ]
                },

            }
        },
        methods: {

            //显示付费客户细节信息
            $_show_detail(index){
                this.cases.items[index].show = true;
            },

            //隐藏付费客户细节信息
            $_hide_detail(index, e){
                e && e.stopPropagation();
                this.cases.items[index].show = false;
            }

        }
    }
</script>


// WEBPACK FOOTER //
// src/components/sec-customer-widget.vue